import swiperSlider from './components/swiper';

const heroSlider = {
	slidesPerView: 1,
	slidesPerGroup: 1,
	spaceBetween: 0,
	autoplay: true,
	speed: 500,
	loop: true,
	grabCursor: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	a11y: {
		prevSlideMessage: 'Previous slide',
		nextSlideMessage: 'Next slide',
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
};

const testemSlider = {
	slidesPerView: 1,
	slidesPerGroup: 1,
	centeredSlides: true,
	spaceBetween: 0,
	loop: true,
	grabCursor: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	a11y: {
		prevSlideMessage: 'Previous slide',
		nextSlideMessage: 'Next slide',
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		992: {
			slidesPerView: 3,
			slidesPerGroup: 1,
			centeredSlides: false,
		},
	},
};

function allPages() {}

function frontpage() {
	document.querySelector('.hero-slider') &&
		swiperSlider('.hero-slider', heroSlider);
	document.querySelector('.testem-slider') &&
		swiperSlider('.testem-slider', testemSlider);
}

function initDOMLoaded() {
	document.removeEventListener('DOMContentLoaded', initDOMLoaded);
	document.querySelector('body.home') && frontpage();
	allPages();
}

// Code runs after page loaded
document.addEventListener('DOMContentLoaded', initDOMLoaded);
